import { render } from "./fx.vue?vue&type=template&id=a94434a6&scoped=true"
import script from "./fx.vue?vue&type=script&lang=js"
export * from "./fx.vue?vue&type=script&lang=js"

import "./fx.vue?vue&type=style&index=0&id=a94434a6&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a94434a6"]])

export default __exports__